import Cookies from 'js-cookie';

export const setCookie = (name: string, value: string, options?: Cookies.CookieAttributes): void => {
    Cookies.set(name, value, options);
};

export const getCookie = (name: string): string | undefined => {
    return Cookies.get(name);
};

export const removeCookie = (name: string, options?: Cookies.CookieAttributes): void => {
    Cookies.remove(name, options);
};

export const deleteAllCookie = (): void => {
    // Get all cookies
    const cookies = document.cookie.split(";");

    for (const cookie of cookies) {
        const eqPos = cookie.indexOf("=");
        const name = eqPos > -1 ? cookie.slice(0, eqPos) : cookie;
        
        // Set the cookie's expiration date to a past date
        document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
    }
}